export const brandFonts = {
  primary: "'Inter', sans-serif",
  secondary: "Gloria Hallelujah",
};
